import React from 'react';
import { Text, TextField } from '@sitecore-jss/sitecore-jss-nextjs';

type IntroCopyProps = {
  anchorId?: string; // Optional prop for `id`
  className?: string;
  fields: {
    title: TextField;
  };
};

const IntroCopy: React.FC<IntroCopyProps> = ({ fields, anchorId, className }) => {
  return (
    <Text
      id={anchorId}
      tag="span"
      className={`subheader-1 text-grey ${className}`}
      field={fields.title}
    />
  );
};

export default IntroCopy;
